module.exports = __webpack_public_path__ + "img/des-4.e884360a.jpg";